
const LIBRARY_OPTIONS_FILTER_VALUE = 'filter';
const LIBRARY_OPTIONS_SORTING_VALUE = 'sorting';
const LIBRARY_OPTIONS_SEARCH_VALUE = 'search';
const LIBRARY_OPTIONS_CONTENT_TAGS_VALUE =  'content_tags';
const LIBRARY_OPTIONS_CONTENT_COUNT_VALUE =  'content_count';

const ALL_COLLECTION_VALUE = 'all';
const SELECTED_ITEM_COLLECTION_VALUE = 'select';
const SELECTED_BY_TAGS_COLLECTION_VALUE = 'tag';
const SELECTED_BY_COLLECTIONS_COLLECTION_VALUE = 'collection';
const SELECTED_BY_MODEL_COLLECTION_VALUE = 'model';
const SELECTED_BY_CATEGORIES_COLLECTION_VALUE = 'category';
const SELECTED_BY_TYPES_COLLECTION_VALUE = 'type';

const LIBRARY_STATE = {
   type: 'section',
   right_side: 'homepage',
   limit: 'x',
   is_page_section: true,
   component_limit: {
      name: 50,
      description: 100,
   },
   show_delete_section_button: true,
};
const SHOWCASE_STATE = {
   icon: 'qr-code',
   type: 'section',
   right_side: 'homepage',
   limit: 'x',
   is_page_section: true,
   section_name: 'Content showcase',
   component_limit: {
      name: 50,
      description: 100,
   },
   show_delete_section_button: true,
}

const STATE_GENERAL_DEFAULT_VALUE = {
   title: '',
   description: '',
};

const STATE_METAS_DEFAULT_VALUE = {
   alignment: 'left',
   content_card_size: 's',
   collections: { type: ALL_COLLECTION_VALUE, ids: [] },
   content_default_sorting: 'date_added:desc',
};


const showcaseDataState = {
   videos_content_showcase: {
      ...SHOWCASE_STATE,
      section_type: 'videos_content_showcase',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         type: 'videos_content_showcase',
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            link_button_text: 'See all videos',
            link_to: '',
         },
      },
   },
   photoset_content_showcase: {
      ...SHOWCASE_STATE,
      section_type: 'photoset_content_showcase',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         type: 'photoset_content_showcase',
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            link_button_text: 'See all photosets',
            link_to: '',
         },
      },
   },
   stories_content_showcase: {
      ...SHOWCASE_STATE,
      section_type: 'stories_content_showcase',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         type: 'stories_content_showcase',
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            link_button_text: 'See all stories',
            link_to: '',
         },
      },
   },
   store_content_showcase: {
      ...SHOWCASE_STATE,
      section_type: 'store_content_showcase',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         type: 'store_content_showcase',
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            link_button_text: 'See all store items',
            link_to: '',
         },
      },
   },
   recorded_content_showcase: {
      ...SHOWCASE_STATE,
      section_type: 'recorded_content_showcase',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         type: 'recorded_content_showcase',
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            link_button_text: 'See all recorded streams',
            link_to: '',
         },
      },
   },
}
const libraryDataState = {
   stories_library: {
      ...LIBRARY_STATE,
      icon: 'stories',
      section_type: 'stories_library',
      section_name: 'Stories library',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            options: [LIBRARY_OPTIONS_FILTER_VALUE, LIBRARY_OPTIONS_SORTING_VALUE],
         },
      },
   },
   video_library: {
      ...LIBRARY_STATE,
      icon: 'videos',
      section_type: 'video_library',
      section_name: 'Video library',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            options: [LIBRARY_OPTIONS_FILTER_VALUE, LIBRARY_OPTIONS_SORTING_VALUE, LIBRARY_OPTIONS_SEARCH_VALUE, LIBRARY_OPTIONS_CONTENT_TAGS_VALUE, LIBRARY_OPTIONS_CONTENT_COUNT_VALUE],
         },
      },
   },
   recorded_livestreams_library: {
      ...LIBRARY_STATE,
      icon: 'livestream',
      section_type: 'recorded_livestreams_library',
      section_name: 'Recorded livestreams library',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            options: [LIBRARY_OPTIONS_FILTER_VALUE, LIBRARY_OPTIONS_SORTING_VALUE, LIBRARY_OPTIONS_SEARCH_VALUE, LIBRARY_OPTIONS_CONTENT_TAGS_VALUE, LIBRARY_OPTIONS_CONTENT_COUNT_VALUE],
         },
      },
   },
   photoset_library: {
      ...LIBRARY_STATE,
      icon: 'photosets',
      section_type: 'photoset_library',
      section_name: 'Photoset library',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            options: [LIBRARY_OPTIONS_FILTER_VALUE, LIBRARY_OPTIONS_SORTING_VALUE, LIBRARY_OPTIONS_SEARCH_VALUE, LIBRARY_OPTIONS_CONTENT_TAGS_VALUE, LIBRARY_OPTIONS_CONTENT_COUNT_VALUE],
         },
      },
   },
   store: {
      ...LIBRARY_STATE,
      icon: 'store',
      section_type: 'store',
      section_name: 'Store',
      default_value: {
         ...STATE_GENERAL_DEFAULT_VALUE,
         metas: {
            ...STATE_METAS_DEFAULT_VALUE,
            options: [LIBRARY_OPTIONS_FILTER_VALUE, LIBRARY_OPTIONS_SORTING_VALUE, LIBRARY_OPTIONS_SEARCH_VALUE,  LIBRARY_OPTIONS_CONTENT_COUNT_VALUE],
         },
      },
   },
}

const getResourceApiType = (resourceType, contentType) => {
   let resourceApiType = null;
   let contentApiType = contentType;
   let icon = '';
   switch (resourceType) {
      case SELECTED_BY_TAGS_COLLECTION_VALUE:{
         resourceApiType = 'tags';
         icon = 'tag';
         break;
      }
      case SELECTED_BY_MODEL_COLLECTION_VALUE:{
         resourceApiType = 'cast_members';
         icon = 'cast-members-new';
         break;
      }
      case SELECTED_BY_COLLECTIONS_COLLECTION_VALUE:{
         if(contentType === 'photoset'){
            resourceApiType = 'photoset_collections';
         }
         if(['video', 'record stream'].includes(contentType)){
            resourceApiType = 'video_collections';
            contentApiType = 'video';
         }
         icon = 'collection';
         break;
      }
      case SELECTED_BY_CATEGORIES_COLLECTION_VALUE: {
         if(contentType === 'store'){
            resourceApiType = 'store_categories';
         }
         icon = 'collection';
         break;
      }
      case SELECTED_BY_TYPES_COLLECTION_VALUE: {
         if(contentType === 'store'){
            resourceApiType = 'store_types';
         }
         icon = 'collection';
         break;
      }

      default:
         break;
   }

   return { resourceApiType, contentApiType, icon };
}

export {
   showcaseDataState,
   libraryDataState,
   LIBRARY_OPTIONS_FILTER_VALUE,
   LIBRARY_OPTIONS_SORTING_VALUE,
   LIBRARY_OPTIONS_SEARCH_VALUE,
   LIBRARY_OPTIONS_CONTENT_TAGS_VALUE,
   LIBRARY_OPTIONS_CONTENT_COUNT_VALUE,
   ALL_COLLECTION_VALUE,
   SELECTED_ITEM_COLLECTION_VALUE,
   SELECTED_BY_TAGS_COLLECTION_VALUE,
   SELECTED_BY_COLLECTIONS_COLLECTION_VALUE,
   SELECTED_BY_MODEL_COLLECTION_VALUE,
   SELECTED_BY_CATEGORIES_COLLECTION_VALUE,
   SELECTED_BY_TYPES_COLLECTION_VALUE,
   getResourceApiType,
}